import type { Ref } from 'vue'
import { computed } from 'vue'

import type { AccountType, Account, Skill, UserShape } from '~/types/user';

export function useAuthUser() {
    const { status, data: session } = useAuth();

    const isAuthenticated = computed(() => status.value === 'authenticated');
    const isLoading = computed(() => status.value === 'loading');

    const user: Ref<UserShape> = computed(() => {
        const u: any = session.value?.data ?? {};
        return {
            id: u.id,
            full_name: u.full_name ?? '',
            email: u.email ?? '',
            image_url: u.image_url ?? '',
            email_verified: u.email_verified,
            signup_step: u.signup_step,
            signup_type: u.signup_type,
            account_type: (u.account_type as AccountType) ?? 'guest',
            permissions: (u.permissions as string[]) ?? [],
            accounts: (u.accounts as Account[]) ?? [],
            skills: (u.skills as Skill[]) ?? [],
            developer_dashboard_last_visited_at: u.developer_dashboard_last_visited_at,
            company_dashboard_last_visited_at: u.company_dashboard_last_visited_at,
            company_users_last_visited_at: u.company_users_last_visited_at,
            complete_profile_modal_last_seen_at: u.complete_profile_modal_last_seen_at,
        }
    });

    const hasAccountType = (list: AccountType[]) => computed(() => list.includes(user.value.account_type));
    const hasPermission = (perm: string) => computed(() => user.value.permissions.includes(perm));

    return { status, session, isAuthenticated, isLoading, user, hasAccountType, hasPermission }
}
